/*eslint-disable no-unused-vars */
//import { axiosInstance } from '../../../api/axios';
import axiosInstanceWithTimeout from '../../../api/axiosWithTimeout';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Member/api/APIEndpoints'; //getNetworksList
import { doctorDetails } from '../../../Member/components/find-provider/data/schema-mock-data';

export const getNetworksList = createAsyncThunk(
  'getNetworksList',
  async (params, { getState }) => {
    //const apiUrl = APIEndpoints.getNetworksList();
    const apiUrl = APIEndpoints.getNetworkTierPriceCompareData();
    const response = await axiosInstanceWithTimeout.get(
      `${apiUrl}${params.UserType}/oid/${params.MemberOID}`,
    );
    return response;
  },
);

/**
 * @method
 */
const prepareSearchParamsUrl = (params) => {
  return new Promise((resolve, reject) => {
    let searchParams = '';
    Object.keys(params).forEach((key, index) => {
      if (params[key]) {
        if (typeof params[key] === 'object') {
          if (Array.isArray(params[key])) {
            if (params[key].length > 0) {
              const keyValues = params[key].join(',');
              searchParams += `/${key}/${keyValues}`;
            }
          } else {
            if (key === 'Network') {
              searchParams += `/${key}/${params[key].value}`;
            } else {
              let objectData = '';
              Object.keys(params[key]).forEach((nestedKey) => {
                objectData += `${params[key][nestedKey]},`;
              });
              searchParams += `/${key}/${objectData.slice(0, -1)}`;
            }
          }
        } else {
          searchParams += `/${key}/${params[key]}`;
        }
        //&& searchParams.includes('maximumradius') === false
        if (Object.keys(params).length - 1 === index) {
          //searchParams += `/maximumradius/${params?.maximumradius || MAXIMUM_FIND_PROVIDER_RADIUS}`
          resolve(searchParams);
        }
      }
    });
  });
};

export const searchProviders = createAsyncThunk(
  'searchProviders',
  async (params, { getState, dispatch }) => {
    const {
      searchProviderParams: { filters, ...searchParams },
      address: UserAddress,
      providerType,
    } = getState().findProvider;
    const { loggedInUserOID, loggedInMemberType } = getState().memberSummary;

    const allSearchParams = {
      //pagesize: 1,
      //pagenumber: 1,
      ...params,
      ...filters,
      ...searchParams,
      //...languages,
      UserAddress,
      //userCoordinates,
    };
    let apiUrl = APIEndpoints.searchDoctors();
    if (providerType === 'facilities') {
      apiUrl = APIEndpoints.searchFacilities();
    }
    const {
      sortby,
      sortdirection,
      specialities,
      DoctorByType,
      FacilityByType,
      ...restOfParams
    } = allSearchParams;

    if (providerType === 'doctors') {
      const DoctorByTypeValues =
        specialities && DoctorByType
          ? [DoctorByType, ...specialities]
          : specialities
          ? specialities
          : DoctorByType
          ? [DoctorByType]
          : [];
      if (DoctorByTypeValues?.length > 0)
        allSearchParams.DoctorByType = [...DoctorByTypeValues];
    }
    if (providerType === 'facilities') {
      const FacilityByTypeValues =
        specialities && FacilityByType
          ? [FacilityByType, ...specialities]
          : specialities
          ? specialities
          : FacilityByType
          ? [FacilityByType]
          : [];
      if (FacilityByTypeValues?.length > 0)
        allSearchParams.FacilityByType = [...FacilityByTypeValues];
    }
    const filteredParams = Object.fromEntries(
      Object.entries(allSearchParams).filter(([key, value]) => value !== null),
    );
    const paramsUrl = await prepareSearchParamsUrl(filteredParams);
    let memberDeatilParams = '';

    memberDeatilParams += `/membertype/${loggedInMemberType}/memberoid/${loggedInUserOID}`;

    const finalApiUrl = apiUrl + paramsUrl + memberDeatilParams;

    const response = await axiosInstanceWithTimeout.get(finalApiUrl);
    response.data.Response.data =
      providerType === 'facilities'
        ? response?.data?.Response?.FacilityResponse || []
        : response?.data?.Response?.SearchDoctors || [];
    return response;
  },
);

/**
 * @method: getSearchProviderFilters
 */
export const getSearchProviderFilters = createAsyncThunk(
  'getSearchProviderFilters',
  async (params, { getState }) => {
    const {
      searchProviderParams: { filters, ...searchParams },
      address: UserAddress,
      //usercoordinates: userCoordinates,
      providerType,
    } = getState().findProvider;
    const { loggedInUserOID, loggedInMemberType } = getState().memberSummary;

    const allSearchParams = {
      ...params,
      ...filters,
      ...searchParams,
      UserAddress,
    };

    let apiUrl = APIEndpoints.searchDoctors();
    if (providerType === 'facilities') {
      apiUrl = APIEndpoints.getFacilityFiltersList();
    }
    const {
      sortby,
      sortdirection,
      specialities,
      DoctorByType,
      FacilityByType,
      ...restOfParams
    } = allSearchParams;

    if (providerType === 'doctors') {
      const DoctorByTypeValues =
        specialities && DoctorByType
          ? [DoctorByType, ...specialities]
          : specialities
          ? specialities
          : DoctorByType
          ? [DoctorByType]
          : [];
      if (DoctorByTypeValues?.length > 0)
        restOfParams.DoctorByType = [...DoctorByTypeValues];
      const filteredParams = Object.fromEntries(
        Object.entries(restOfParams).filter(([key, value]) => value !== null),
      );
      const newRestOfParams = { ...filteredParams };
      if (Object.prototype.hasOwnProperty.call(newRestOfParams, 'speciality')) {
        newRestOfParams.FacilityByType = newRestOfParams.speciality;
        delete newRestOfParams.speciality;
      }
      if (
        Object.prototype.hasOwnProperty.call(newRestOfParams, 'facilityname')
      ) {
        newRestOfParams.FacilityByName = newRestOfParams.facilityname;
        delete newRestOfParams.facilityname;
      }
      const paramsUrl = await prepareSearchParamsUrl(newRestOfParams);
      let memberDeatilParams = '';

      memberDeatilParams += `/membertype/${loggedInMemberType}/memberoid/${loggedInUserOID}`;
      const isFilter = `/filterdata/true`;

      const finalApiUrl = apiUrl + paramsUrl + memberDeatilParams + isFilter;

      const response = await axiosInstanceWithTimeout.get(finalApiUrl);
      return response;
    }
    if (providerType === 'facilities') {
      const FacilityByTypeValues =
        specialities && FacilityByType
          ? [FacilityByType, ...specialities]
          : specialities
          ? specialities
          : FacilityByType
          ? [FacilityByType]
          : [];
      if (FacilityByTypeValues?.length > 0)
        restOfParams.FacilityByType = [...FacilityByTypeValues];

      return '';
    }
    return '';
  },
);

export const getDoctorDetails = createAsyncThunk(
  'getDoctorDetails',
  async (params, { getState }) => {
    //"OID", // from params
    //"Network": //from state,
    //"UserCoordinates": //from state
    const {
      searchProviderParams: { Network, UserCoordinates },
    } = getState().findProvider;
    const allParams = { ...params };
    if (Network) {
      allParams.Network = Network;
    }
    if (UserCoordinates) {
      allParams.UserCoordinates = UserCoordinates;
    }
    return doctorDetails;
  },
);
